import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { DesignSnackSettingsContainer } from "@/components/features/snack/snack/settings/ui";

import { useGetParams } from "./hooks/use-get-params";

export const DesignSnackSettingPage = () => {
	const { hotelID } = useGetParams();

	return (
		<PageMeta
			title="スナックページの設定"
			url={generatePath(PATHS.HOTEL.RESERVATION_PAGE.SNACK.SETTING, { hotelID })}
		>
			<DesignSnackSettingsContainer hotelID={hotelID} />
		</PageMeta>
	);
};

DesignSnackSettingPage.displayName = "DesignSnackSettingPage";
